import auth from "../../middlewares/auth";

export const ticketRoutes = [
    {
        // path: '/tickets/:contact_id?/:company_id?',
        path: '/tickets',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/Ticket'),
        name: 'tickets',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
    {
        path: '/new-tickets',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/NewTickets'),
        name: 'new_tickets',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
    {
        path: '/resolved-tickets',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/ResolvedTicket.vue'),
        name: 'resolved_tickets',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
    {
        path: '/create-ticket',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/TicketForm'),
        name: 'create-ticket',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
    {
        path: '/ticket/:ticket_number',
        component: () => import(/* webpackChunkName: "tickets" */ '../../views/tickets/ViewTicket'),
        name: 'view-ticket',
        meta: {
            middleware: [
                auth
            ],
            requiredPermissions: ['ticket-manage']
        }
    },
]